<div class="wrapper">
  <h2>Sorry, the page you are looking for cannot be found.</h2>
  <h3>
    Please contact us at
    <a href="mailto:calvin.nursing.emr@gmail.com">calvin.nursing.emr&#64;gmail.com</a>
    for help!
  </h3>
</div>